import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Admin from "./Admin";
import CreatePage from "./component/demo/CreatePage";
import ChatPage from "./component/demo/chatbot/ChatPage";
import Navbar from "./component/navbar/Navbar";
import HeroSection from "./component/hero/HeroSection";
import ServiceProcess from "./component/serviceprocess/ServiceProcess";
import Facilities from "./component/facilities/Facilities";
import ContextException from "./component/contextexception/ContextException";
import Services from "./component/services/Services";
import Testimonial from "./component/testimonials/Testimonial";
import ContactUs from "./component/contact/ContactUs";
import Footer from "./component/footer/Footer";
import Login from "./component/login/Login";
import Dashboard from './component/dashboard/Dashbrd';
import DemoDashboard from "./component/demodashboard/demodashboard";
import Demochats from './component/dashboard/chat/Demochats';
import Cocdashboard from './component/dashboard/chat/codeofconduct/Cocdashboard';
import { Box } from "@mui/material";
import DemoChatBot from "./component/demochatbotpage/demochatbot";
import AIAgentPage from "./component/Aiagents/AIAgentPage";
import ServiceDescri from "./component/servicedescribe/servicedescri"
import Voiceplots from "./component/VoicePlots/Voiceplots";
import Demo from "./component/healthcare/Demo";
import DemoCOC from "./component/healthcare/CodeofC/demo-coc";
import Income from "./component/healthcare/CodeofC/demo-income";
import Pricing from "./component/Pricings/pricing";
import Products from "./component/ProductsPage/Projects";
import Ccaidemo from "./component/ProductsPage/ccaiDemo";
import Callsenry from "./component/Callsentry/callsentry"
import ComomingSoon from "./component/demodashboard/usecases/comingsoon";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};



function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* HOME PAGE – FULLY CONTROLLED WHITE + FIXED WIDTH */}
          <Route
            path="/"
            element={
              <Box
                sx={{
                  backgroundColor: '#1e1e1e',     // Force white page
                  minHeight: '100vh',
                  width:'screen',
                }}
              >
                
                <Navbar />
                <HeroSection />
                <DemoDashboard />
                <ServiceProcess />
                <Facilities />
                <ContextException />

                {/* ==== FORCED WHITE & 1200px FIXED SECTION ==== */}
                <Box
                  sx={{
                    // backgroundColor: '#fff',
                    // width: '1200px',
                    maxWidth: '100%',
                    mx: 'auto',
                    py: { xs: 6, md: 10 },
                    position: 'relative',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      inset: 0,
                      backgroundColor: '#1e1e1e',
                      zIndex: -1,
                    },
                  }}
                >
                  
                </Box>
                {/* =========================================== */}

                <Services />
                <Testimonial />
                <ContactUs />
                <Footer />
              </Box>
            }
          />

          {/* OTHER ROUTES */}
          <Route path="/login" element={<Login />} />
          <Route path="/create-bot" element={<CreatePage />} />
          <Route path="/mebot-chat" element={<ChatPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/demochat" element={<Demochats />} />
          <Route path="/codeofconduct" element={<Cocdashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/chat" element={<DemoChatBot />} />
          <Route path="/ai-agent" element={<AIAgentPage />} />
          <Route path="/servicedescri" element={<ServiceDescri />} />
          <Route path="/voiceplots" element={<Voiceplots />} />
          <Route path="/contactus" element={<ContactUs />} />
          {/* <Route path="/Coc" element={<Coc />} /> */}
          <Route path="/cocdashboard" element={<Cocdashboard />} />
          <Route path="/healthcare-demo" element={<Demo />} />  
          <Route path="/coc-demo" element={<DemoCOC/>} />
          <Route path="/demo-income" element={<Income/>} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/products" element={<Products />} />
          <Route path="/ccai-demo" element={<Ccaidemo />} />
          <Route path="/callsentry" element={<Callsenry />} />
          <Route path="/comingsoon" element={<ComomingSoon />} />





        {/* Use  /comingsoon for temp use*/}
        </Routes>
      </div>
    </Router>
  );
}

export default App;


